export default "__VITE_ASSET__DBE90Zgx__"